var _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInspiring(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "191.408 170.909 22.74 23.82",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 12.04,
    cy: 1.81,
    r: 1.35,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#fdc31e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#fcbf1a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#f8ad0b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f7a706"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 21.65,
    cy: 10.96,
    r: 1.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-3",
    cx: 2.35,
    cy: 10.96,
    r: 1.35,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-4",
    cx: 18.63,
    cy: 4.38,
    r: 1.42,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-5",
    cx: 5.4,
    cy: 4.38,
    r: 1.42,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-6",
    cx: 12,
    cy: 11.91,
    r: 6.39,
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-7",
    cx: 12.04,
    cy: 21.77,
    r: 2.63,
    xlinkHref: "#radial-gradient"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.86,1.09h0V2.52a.92.92,0,0,1-.81,1,.92.92,0,0,1-.81-1h0V1.09a.91.91,0,0,1,.82-1A.93.93,0,0,1,12.86,1.09Z",
    transform: "matrix(1, 0, 0, 1, 190.777771, 170.818924)",
    style: {
      fill: "url(#radial-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.94,10.14h1.43a.92.92,0,0,1,1,.81.94.94,0,0,1-1,.81H20.94a.93.93,0,0,1-1-.82A.94.94,0,0,1,20.94,10.14Z",
    transform: "matrix(1, 0, 0, 1, 190.777771, 170.818924)",
    style: {
      fill: "url(#radial-gradient-2)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1.63,10.14H3.06a.92.92,0,0,1,1,.81.93.93,0,0,1-1,.81H1.63a.93.93,0,0,1-1-.82A.94.94,0,0,1,1.63,10.14Z",
    transform: "matrix(1, 0, 0, 1, 190.777771, 170.818924)",
    style: {
      fill: "url(#radial-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M19.71,4.47h0l-1,1a.93.93,0,0,1-1.29.12.93.93,0,0,1,.16-1.29h0l1-1a.93.93,0,0,1,1.29-.11A.92.92,0,0,1,19.71,4.47Z",
    transform: "matrix(1, 0, 0, 1, 190.777771, 170.818924)",
    style: {
      fill: "url(#radial-gradient-4)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M4.33,4.47h0l1,1a.93.93,0,0,0,1.29.12.94.94,0,0,0-.17-1.29h0l-1-1a.93.93,0,0,0-1.29-.11A.92.92,0,0,0,4.33,4.47Z",
    transform: "matrix(1, 0, 0, 1, 190.777771, 170.818924)",
    style: {
      fill: "url(#radial-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M16.31,7.05A6.14,6.14,0,0,0,5.86,11.43a6.06,6.06,0,0,0,1.54,4A8,8,0,0,1,8.85,18a.75.75,0,0,0,.73.58l4.91,0a.75.75,0,0,0,.73-.58,8.14,8.14,0,0,1,1.41-2.51,5.93,5.93,0,0,0,1.51-4.05A6.07,6.07,0,0,0,16.31,7.05Zm-.68,4.15-4.16,5a.18.18,0,0,1-.31-.13l.36-2.82a.17.17,0,0,0-.17-.18H8.51a.17.17,0,0,1-.13-.28l4.16-5a.18.18,0,0,1,.31.13l-.36,2.82a.17.17,0,0,0,.17.19h2.83A.16.16,0,0,1,15.63,11.2Z",
    transform: "matrix(1, 0, 0, 1, 190.777771, 170.818924)",
    style: {
      fill: "url(#radial-gradient-6)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M15.08,20.39V21.5a1.79,1.79,0,0,1-.27.9l-.49.76a1.78,1.78,0,0,1-1.38.75H11.18a1.77,1.77,0,0,1-1.4-.73l-.49-.73A1.65,1.65,0,0,1,9,21.53V20.41a.74.74,0,0,1,.74-.75l4.58,0a.75.75,0,0,1,.75.76Z",
    transform: "matrix(1, 0, 0, 1, 190.777771, 170.818924)",
    style: {
      fill: "url(#radial-gradient-7)"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspiring);
export default __webpack_public_path__ + "static/media/Inspiring.72d5e6aa67262669759ebf44cc8765fc.svg";
export { ForwardRef as ReactComponent };